'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { CalendarEvent } from '../../_components/CalendarEvent';
import type { ClientData } from '../../page';
import { CalendarSection } from './Calendar';
import { CallFormSection } from './CallForm';
import { CodeVerificationForm } from './CodeVerificationForm';
import { ProgressBar } from './ProgressBar';
import { SummarySection } from './Summary';
export function PhoneCallBookingSection() {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fullname: "",
      phoneNumber: "",
      message: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [clientData, setClientData] = useState(t0);
  const [activeStepIdx, setActiveStepIdx] = useState(1);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedDay, setSelectedDay] = useState(t1);
  const [selectedEvent, setSelectedEvent] = useState(null);
  let t2;
  if ($[2] !== activeStepIdx || $[3] !== selectedDay || $[4] !== selectedEvent) {
    t2 = {
      id: 1,
      title: "Wybierz dat\u0119 spotkania",
      content: <CalendarSection selectedDay={selectedDay} setSelectedDay={setSelectedDay} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} activeStepIdx={activeStepIdx} setActiveStepIdx={setActiveStepIdx} />
    };
    $[2] = activeStepIdx;
    $[3] = selectedDay;
    $[4] = selectedEvent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== activeStepIdx) {
    t3 = {
      id: 2,
      title: "Uzupe\u0142nij swoje dane",
      content: <CallFormSection activeStepIdx={activeStepIdx} setActiveStepIdx={setActiveStepIdx} setClientData={setClientData} />
    };
    $[6] = activeStepIdx;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== activeStepIdx || $[9] !== clientData || $[10] !== selectedEvent) {
    t4 = {
      id: 3,
      title: "Potwierd\u017A numer telefonu",
      content: <CodeVerificationForm activeStepIdx={activeStepIdx} setActiveStepIdx={setActiveStepIdx} clientData={clientData} selectedEvent={selectedEvent} />
    };
    $[8] = activeStepIdx;
    $[9] = clientData;
    $[10] = selectedEvent;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== selectedDay || $[13] !== selectedEvent) {
    t5 = {
      id: 4,
      title: "Podsumowanie",
      content: <SummarySection selectedEvent={selectedEvent} selectedDay={selectedDay} />
    };
    $[12] = selectedDay;
    $[13] = selectedEvent;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = [t2, t3, t4, t5];
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== activeStepIdx || $[21] !== t6) {
    t7 = <section className="flex flex-row gap-4"><ProgressBar activeStepIdx={activeStepIdx} steps={t6} /></section>;
    $[20] = activeStepIdx;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}